import { BankCCType } from "@/types/bankAccountsCCType";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useBankAccountsCCStore = defineStore(
  "bankAccountsCC",
  () => {
    const bankCC = ref<BankCCType[]>([]);

    return {
      bankCC,
    };
  },
  {
    persist: true,
  }
);
